var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.559,
    height: 14.485,
    viewBox: "0 0 20.559 14.485",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41163",
    "data-name": "Group 41163",
    transform: "translate(-217.749 -54.727)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78006",
    "data-name": "Path 78006",
    d: "M217.749,56.3c.03-.109.056-.219.091-.326a1.807,1.807,0,0,1,1.722-1.241c1.258-.005,2.515,0,3.773,0H236.4a1.8,1.8,0,0,1,1.84,1.346,2.149,2.149,0,0,1,.065.536q.005,5.359,0,10.718a1.806,1.806,0,0,1-1.886,1.883H219.683a1.807,1.807,0,0,1-1.9-1.5.532.532,0,0,0-.03-.073Zm2.106-.353c.061.067.1.115.148.161l7.469,7.506a.7.7,0,0,0,1.118,0l7.483-7.52c.04-.04.075-.084.126-.143Zm-.015,12.042h16.377l-5.169-5.132c-.039.037-.092.086-.143.137-.5.5-1,1.009-1.5,1.51a1.9,1.9,0,0,1-2.748,0c-.3-.3-.6-.608-.907-.912l-.736-.737Zm-.875-11.137V67.088l5.156-5.118ZM237.088,67.1V56.876l-5.152,5.108Z",
    transform: "translate(0)",
    fill: "#4affbc"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailNew);
export default __webpack_public_path__ + "static/media/email-new.482cf38be3313d0920fef81e351d6729.svg";
export { ForwardRef as ReactComponent };